import { render, staticRenderFns } from "./hazopGuideword.vue?vue&type=template&id=1730941d"
import script from "./hazopGuideword.vue?vue&type=script&lang=js"
export * from "./hazopGuideword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1730941d')) {
      api.createRecord('1730941d', component.options)
    } else {
      api.reload('1730941d', component.options)
    }
    module.hot.accept("./hazopGuideword.vue?vue&type=template&id=1730941d", function () {
      api.rerender('1730941d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/hazopGuideword.vue"
export default component.exports